module.exports = __webpack_public_path__ + "img/04.8e313e34.jpg";